// extracted by mini-css-extract-plugin
export var childrenContent = "cd_jd";
export var content = "cd_cF";
export var titleContent = "cd_jf";
export var titleContentLabel = "cd_jg";